import $axios from '../../settings/axios.js';
//import settings from "../../settings/settings";

const state = {
  appointment: null,
  done: false,
  appointmentid: null,
  wipno: null,
  encryptData: '',
  messages: null
};

const getters = {
  appointment: state => state
};

const actions = {
  async addAppointment({ commit }, payload) {
    return await $axios.post(payload.endpoint, payload.data).then(
      response => {
        commit('SET_APPOINTMENT', response.data);
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: this.getters['user/user'].guid,
          error: {
            message: 'SET_APPOINTMENT_ADD',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataAppointment', errorPayload);
      }
    );
  },
  async confirmAppointment({ commit }, payload) {
    payload.data.appointment = state.appointment;
    return await $axios.post(payload.endpoint, payload.data).then(
      response => {
        commit('SET_DONE', response.data);
      },
      error => {
        const errorPayload = {
          modal: true,
          send: false,
          traceid: this.getters['user/user'].guid,
          error: {
            message: 'SET_APPOINTMENT_CONFIRM',
            jsondata: JSON.stringify(error)
          }
        };
        this.dispatch('errors/setDataAppointment', errorPayload);
      }
    );
  }
};
const mutations = {
  SET_APPOINTMENT(state, payload) {
    state.appointment = payload;
  },
  SET_DONE(state, payload) {
    state.appointmentid = payload.appointmentid;
    state.wipno = payload.wipno;
    state.done = true;
    state.encryptData = payload.encryptdata;
    state.messages = payload.messages;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
